import { useHistory, useLocation } from "react-router-dom";
import Container from "src/components/layout/Container";
import colors from "src/utils/colors";
import tw from "src/utils/tw";

interface Props {
  routes?: Array<{ path: string }>;
  route?: {
    path: string;
  };
}

export function StartHeader(props: Props) {
  const location = useLocation();
  const history = useHistory();

  let currentIndex = props.routes?.findIndex(
    (r) => r.path === location.pathname
  );

  function onClickStep(i) {
    const step = props.routes[i];
    history.push(step.path);
  }

  // console.log("props.routes", props.routes);

  function renderSteps() {
    const steps = props.routes
      .filter((r) => r.path !== "/start/success")
      .map((r, i) => {
        const isPreviousStep = i < currentIndex;
        const isCurrentStep = i === currentIndex;

        return (
          <button
            key={i}
            className={tw(
              "flex-1",
              "px-1",
              "flex",
              "bg-errors",
              "pt-1",
              "pb-4",
              isPreviousStep ? "cursor-pointer" : "cursor-auto"
            )}
            css={[
              isPreviousStep && {
                "&:hover": {
                  "& .step-button": {
                    background: colors.action,
                  },
                },
              },
            ]}
            onClick={isPreviousStep ? () => onClickStep(i) : undefined}
          >
            <div
              className={tw(
                isCurrentStep && "bg-organization",
                isPreviousStep && "bg-dark",
                !isPreviousStep && !isCurrentStep && "bg-borderGray",
                "transition",
                "h-1.5",
                "rounded-full",
                "transition",
                "w-full",
                "step-button"
              )}
            ></div>
          </button>
        );
      });

    return <div className="flex max-w-lg">{steps}</div>;
  }

  let steps;

  if (props.routes) {
    steps = renderSteps();
  }

  return (
    <>
      <div className="fixed left-0 top-0 z-10 flex h-[50px] w-full items-center bg-white shadow">
        <Container large className="flex-1">
          <a href="https://captyn.com">
            <img
              src="/img/captyn-logo.svg"
              alt="Captyn"
              width="91"
              height="16"
            />
          </a>
        </Container>
      </div>
      {props.routes && (
        <div className="mt-[50px] flex items-center border-b border-borderGray py-4">
          <Container large className="flex-1">
            <h2 className="mb-1 mt-0.5">Onboarding</h2>
            {steps}
          </Container>
        </div>
      )}
    </>
  );
}
